export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Solo contanti al ristorante. Pagamento con carta non accettato.',
  },
};
